export default __webpack_public_path__ + "69493cfdf27447e76032d83d1ae39b46.svg";